let HeaderLinksData = [{
    "title": "Technology",
    "route": "technology"
}, {
    "title": "Vendor",
    "route": "vendor"
}, {
    "title": "Contact us",
    "route": "contact"
}]

export default HeaderLinksData
